export interface NpsMonthlyPoint {
  month: string
  nps_score: number
}

export interface NpsBreakdown {
  promoters: number
  passives: number
  detractors: number
}

export interface NpsFeedbackItem {
  client: string
  project: string
  score: number
  category: string
  comment: string
}

/** Satisfaction levels from "How satisfied are you with..." survey (5-point Likert) */
export interface SatisfactionBreakdown {
  veryDissatisfied: number
  dissatisfied: number
  neutral: number
  satisfied: number
  verySatisfied: number
}

export interface SatisfactionAspect {
  aspect: string
  breakdown: SatisfactionBreakdown
}

export interface NpsData {
  currentScore: number
  responses: number
  changeVsLastMonth: number
  monthlyTrend: NpsMonthlyPoint[]
  breakdown: NpsBreakdown
  feedback: NpsFeedbackItem[]
  /** "How satisfied are you with..." aspect ratings (percentages per level) */
  satisfactionAspects: SatisfactionAspect[]
}

export const NPS_DATA: NpsData = {
  currentScore: 68,
  responses: 42,
  changeVsLastMonth: 6,
  monthlyTrend: [
    { month: 'Jan', nps_score: 55 },
    { month: 'Feb', nps_score: 60 },
    { month: 'Mar', nps_score: 68 },
    { month: 'Apr', nps_score: 72 },
  ],
  breakdown: {
    promoters: 60,
    passives: 25,
    detractors: 15,
  },
  feedback: [
    {
      client: 'Client A',
      project: 'Warehouse Design',
      score: 10,
      category: 'Speed',
      comment: 'Great turnaround',
    },
    {
      client: 'Client B',
      project: 'Structural Review',
      score: 6,
      category: 'Communication',
      comment: 'Slow responses',
    },
    {
      client: 'Client C',
      project: 'Foundation Report',
      score: 9,
      category: 'Quality',
      comment: 'Thorough and professional',
    },
    {
      client: 'Client D',
      project: 'Site Inspection',
      score: 7,
      category: 'Communication',
      comment: 'Clear documentation',
    },
    {
      client: 'Client E',
      project: 'Design Review',
      score: 8,
      category: 'Speed',
      comment: 'Met deadlines as promised',
    },
  ],
  satisfactionAspects: [
    {
      aspect: 'Quality of the final deliverable',
      breakdown: { veryDissatisfied: 0, dissatisfied: 2, neutral: 8, satisfied: 40, verySatisfied: 50 },
    },
    {
      aspect: 'Expertise of the advice provided',
      breakdown: { veryDissatisfied: 0, dissatisfied: 0, neutral: 5, satisfied: 35, verySatisfied: 60 },
    },
    {
      aspect: 'Responsiveness and speed',
      breakdown: { veryDissatisfied: 2, dissatisfied: 5, neutral: 15, satisfied: 43, verySatisfied: 35 },
    },
    {
      aspect: 'Clarity and conciseness of communication',
      breakdown: { veryDissatisfied: 0, dissatisfied: 3, neutral: 12, satisfied: 45, verySatisfied: 40 },
    },
    {
      aspect: 'Ease to work with',
      breakdown: { veryDissatisfied: 0, dissatisfied: 0, neutral: 5, satisfied: 30, verySatisfied: 65 },
    },
  ],
}
